module.exports = "https://www.gc-qa.gnp.com.mx/f6849029a8c21b52de05ddccc4155690.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/pago/3.png
// module id = 1042
// module chunks = 0 1